import { Component } from "@opten/compiler/metadata/component";
import { toggleClass } from "@opten/dom/toggle-class";

@Component({ className: "js-input" })
export class InputComponent {
	private formField: HTMLElement;
	private valueShadows: HTMLElement[];
	private labels: HTMLElement[];
	private hasValueClass = "has-value";
	private isActiveClass = "is-active";

	constructor(private input: HTMLInputElement) {
		this.formField = input.closest(".c-formfield") as HTMLElement;
		this.valueShadows = Array.from(
			document.querySelectorAll(
				`.js-input-shadow[data-name='${this.input.name}']`
			)
		) as HTMLElement[];
		this.labels = Array.from(
			input
				.closest("form")
				.querySelectorAll(`[data-group="${this.input.name}"]`)
		) as HTMLElement[];

		input.addEventListener("change", () => this.setValueClass());
		input.addEventListener("input", () => this.setValueClass());

		this.setValueClass();
	}

	private setValueClass() {
		const hasData =
			this.input.placeholder ||
			this.input.value ||
			this.input.type == "date" ||
			this.input.type == "time" ||
			this.input.type == "file";
		toggleClass(this.formField, this.hasValueClass, !!hasData);
		this.updateInputHeight();
		if (this.valueShadows && this.valueShadows.length > 0) {
			this.valueShadows.forEach((shadow) => {
				shadow.innerHTML = this.input.value;
			});
		}
		if (this.labels && this.labels.length > 0) {
			let value = this.input.value;
			if (
				this.input.type.toLowerCase() === "radio" ||
				this.input.type.toLowerCase() === "checkbox"
			) {
				value = this.input.checked ? this.input.value : "";
			}
			this.labels.forEach((label) => {
				const isActiveClass =
					label.getAttribute("data-active-class") ||
					this.isActiveClass;
				const htmlFor = label.htmlFor || label.getAttribute("data-for");
				toggleClass(
					label,
					isActiveClass,
					value && htmlFor == this.input.id
				);
			});
		}
	}

	private updateInputHeight() {
		if (this.input.tagName.toLowerCase() === "textarea") {
			this.input.style.height = "";
			this.input.style.height =
				(this.input.scrollHeight || 65) + 2 + "px";
		}
	}
}
